document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var botonesSeleccionRutinaTratamiento = document.querySelectorAll('.btn_SeleccionRutinaTratamiento');
  if (!botonesSeleccionRutinaTratamiento.length) return;

  function manejarClickSeleccionRutinaTratamiento(event) {
    var boton = event.currentTarget;
    var variantId = boton.getAttribute('data-variant-id_SeleccionRutinaTratamiento');

    if (!variantId) {
      console.warn('SeleccionRutinaTratamiento: falta data-variant-id_SeleccionRutinaTratamiento en el botón', boton);
      return;
    }

    if (boton.getAttribute('aria-disabled') === 'true') return;
    boton.setAttribute('aria-disabled', 'true');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Error añadiendo al carrito');
          });
        }
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .catch(function (error) {
        console.error('Error_SeleccionRutinaTratamiento:', error);
        boton.removeAttribute('aria-disabled');
      });
  }

  function manejarTecladoSeleccionRutinaTratamiento(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      manejarClickSeleccionRutinaTratamiento(event);
    }
  }

  botonesSeleccionRutinaTratamiento.forEach(function (boton) {
    boton.addEventListener('click', manejarClickSeleccionRutinaTratamiento);
    boton.addEventListener('keydown', manejarTecladoSeleccionRutinaTratamiento);
  });
});